import {
  faCloudShowers,
  faFire,
  faHandHoldingDroplet,
  faHouseFloodWater,
  faHurricane,
  faTemperatureSun,
  faWindWarning,
} from '@fortawesome/pro-solid-svg-icons';

const HAZARD_CATEGORIES = [
  {
    label: 'Dry spell',
    id: 'dry-spell',
    icon: faHandHoldingDroplet,
  },
  {
    label: 'Extreme rainfall',
    id: 'extreme-precipitation',
    icon: faCloudShowers,
  },
  {
    label: 'Floods',
    id: 'floods',
    icon: faHouseFloodWater,
  },
  {
    label: 'Heat wave',
    id: 'heat-wave',
    icon: faTemperatureSun,
  }, {
    label: 'Fire',
    id: 'fire',
    icon: faFire,
  },
  {
    label: 'Extreme wind',
    id: 'extreme-wind',
    icon: faWindWarning,
  },
  {
    label: 'Tropical cyclones',
    id: 'tropical-cyclones',
    icon: faHurricane,
  },
];

export { HAZARD_CATEGORIES }